import React, { useState } from 'react';
import s from './index.module.scss';
import { FormattedMessage } from 'react-intl';

/**
 * @param {boolean} isSoldOut - 是否售罄
 * @param {Array} getJumpLink - 跳转按钮数据（tag, link, name_key）
 * @param {Array} goodsShops - 弹出商城数据（name_key, link）
 * @param {string} buyText - 主按钮文案
 */
const BuySectionWithShopList = ({ isSoldOut, getJumpLink = [], goodsShops = [], buyText = '购买' }) => {
  const [showSecondaryBuyBtn, setShowSecondaryBuyBtn] = useState(false);
  const [reload, setReload] = useState(false);

  const handleShopClick = () => {
    setShowSecondaryBuyBtn(true);
  };

  const handleLeave = () => {
    setShowSecondaryBuyBtn(false);
  };

  const renderMainButton = () => {
    if (isSoldOut) {
      return (
        <div className={s.subGreyBuy}>
          <div className={s.buy_a}>{buyText}</div>
        </div>
      );
    }

    if (getJumpLink.length > 0) {
      return getJumpLink.map((item, index) => (
        <div className={s.subBuy} key={item.name_key + index}>
          <a
            className={s.buy_a}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id={item.tag} />
          </a>
        </div>
      ));
    }

    return (
      <div className={s.subBuy} onClick={handleShopClick}>
        <div className={s.buy_a}>{buyText}</div>
      </div>
    );
  };

  const renderShopList = () => {
    if (!(goodsShops?.length > 0 && !isSoldOut)) return null;
    
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center' }} className={s.BuySectionWithShopListContainer}>
        <div className={s.shopArrow}></div>
        <div>
          <div
            className={s.wrapMall}
            name="wrapMall"
            style={{
              top: '47px',
              left: '-70px',
              ...(showSecondaryBuyBtn ? { display: 'block' } :''),
            }}
          >
            <div className={s.mallBox}>
              {goodsShops.map((item, index) => (
                <a
                  className={s.mallItem}
                  key={item.name_key + index}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    setReload(!reload);
                    // 可扩展点击逻辑
                  }}
                >
                  <FormattedMessage id={item.name_key} />
                </a>
              ))}
            </div>
            <div style={{ height: 16 }}></div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{ display: 'inline-block' }}
      onMouseLeave={handleLeave}
    >
      {renderMainButton()}
      {renderShopList()}
    </div>
  );
};

export default BuySectionWithShopList;